import { create } from "zustand";
import { notificationService } from "./notificationService";
import { NotificationState } from "./types";

export const useNotificationStore = create<NotificationState>((set, get) => ({
  notifications: [],
  isLoading: false,
  error: null,

  unreadCount: () => get().notifications.filter((n) => !n.is_read).length,

  fetchNotifications: async () => {
    set({ isLoading: true, error: null });
    try {
      const notifications = await notificationService.getMyNotifications();
      set({ notifications, isLoading: false });
    } catch (error) {
      set({
        isLoading: false,
        error: error instanceof Error ? error.message : "Failed to load notifications",
      });
    }
  },

  markAllRead: async () => {
    if (get().notifications.every((n) => n.is_read)) return;
    try {
      await notificationService.markAllRead();
      set((state) => ({
        notifications: state.notifications.map((n) => ({ ...n, is_read: true })),
      }));
    } catch {
      // Not critical — they'll be marked next time
    }
  },
}));
